import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  CAMPAIGN_TYPE_OPTIONS,
  CHANNEL_OPTIONS,
  GOAL_OPTIONS,
  SEND_MODE_OPTIONS,
} from "../../constants/leadCampaignEnums";

const LeadCampaignFormDialog = ({
  open,
  onClose,
  onSubmit,
  initialData,
  groups,
  saving,
}) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    groupId: "",
    campaignType: 1,
    channel: 1,
    goal: 1,
    smsText: "",
    landingUrl: "",
    batchSize: "",
    sendMode: 1,
  });
  const [submitError, setSubmitError] = useState("");

  useEffect(() => {
    if (!open) return;
    setSubmitError("");
    setForm({
      title: initialData?.title || "",
      description: initialData?.description || "",
      groupId: initialData?.groupId || "",
      campaignType: initialData?.campaignType || 1,
      channel: initialData?.channel || 1,
      goal: initialData?.goal || 1,
      smsText: initialData?.smsText || "",
      landingUrl: initialData?.landingUrl || "",
      batchSize: initialData?.batchSize || "",
      sendMode: initialData?.sendMode || 1,
    });
  }, [open, initialData]);

  const handleSubmit = async () => {
    if (!form.title?.trim()) {
      setSubmitError("عنوان کمپین الزامی است.");
      return;
    }
    if (!form.groupId) {
      setSubmitError("گروه مخاطب الزامی است.");
      return;
    }
    const payload = {
      ...form,
      groupId: Number(form.groupId),
      batchSize: form.batchSize ? Number(form.batchSize) : null,
      sendMode: Number(form.sendMode) || 1,
    };
    const result = await onSubmit(payload);
    if (result?.error) setSubmitError(result.error);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{initialData ? "ویرایش کمپین" : "کمپین جدید"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="عنوان"
              fullWidth
              required
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>گروه مخاطب</InputLabel>
              <Select
                label="گروه مخاطب"
                value={form.groupId}
                onChange={(e) => setForm({ ...form, groupId: e.target.value })}
              >
                {(groups || []).map((g) => (
                  <MenuItem key={g.id} value={g.id}>{g.title}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="توضیحات"
              fullWidth
              multiline
              minRows={2}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>نوع کمپین</InputLabel>
              <Select
                label="نوع کمپین"
                value={form.campaignType}
                onChange={(e) => setForm({ ...form, campaignType: e.target.value })}
              >
                {CAMPAIGN_TYPE_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>کانال</InputLabel>
              <Select
                label="کانال"
                value={form.channel}
                onChange={(e) => setForm({ ...form, channel: e.target.value })}
              >
                {CHANNEL_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>هدف</InputLabel>
              <Select
                label="هدف"
                value={form.goal}
                onChange={(e) => setForm({ ...form, goal: e.target.value })}
              >
                {GOAL_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="متن پیامک"
              fullWidth
              multiline
              minRows={2}
              value={form.smsText}
              onChange={(e) => setForm({ ...form, smsText: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="لینک لندینگ"
              fullWidth
              value={form.landingUrl}
              onChange={(e) => setForm({ ...form, landingUrl: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>حالت ارسال</InputLabel>
              <Select
                label="حالت ارسال"
                value={form.sendMode}
                onChange={(e) => setForm({ ...form, sendMode: e.target.value })}
              >
                {SEND_MODE_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={Number(form.sendMode) === 2 ? "اندازه دسته (خودکار)" : "اندازه هر دسته ارسال"}
              type="number"
              fullWidth
              value={form.batchSize}
              onChange={(e) => setForm({ ...form, batchSize: e.target.value })}
              helperText={
                Number(form.sendMode) === 1
                  ? "مثلاً 200 — هر بار «ارسال» تا این تعداد پیامک می‌رود."
                  : "در حالت خودکار همه مخاطبین باقی‌مانده یکجا ارسال می‌شوند."
              }
            />
          </Grid>
          {submitError ? (
            <Grid item xs={12}>
              <TextField error helperText={submitError} fullWidth disabled />
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>انصراف</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadCampaignFormDialog;
